export default __webpack_public_path__ + "static/media/holyfamily.78149139.jpg";